export function formatDate(date?: string | number | Date | null): string {
  if (!date) return 'soon';
  try {
    const d = date instanceof Date ? date : new Date(date);
    return new Intl.DateTimeFormat(undefined, {
      year: d.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined,
      month: 'short',
      day: 'numeric',
    }).format(d);
  } catch {
    return 'soon';
  }
}

export function formatRelativeTime(date?: string | number | Date | null): string {
  if (!date) return 'soon';
  try {
    const d = date instanceof Date ? date : new Date(date);
    const now = new Date();
    // Difference in whole days (future-positive)
    const msPerDay = 24 * 60 * 60 * 1000;
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const startOfThatDay = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const diffDays = Math.round((startOfThatDay - startOfToday) / msPerDay);

    if (diffDays <= 0) return 'today';
    if (diffDays === 1) return 'tomorrow';
    if (diffDays <= 30) return `in ${diffDays} days`;
    // For far futures, fall back to a short date
    return formatDate(d);
  } catch {
    return 'soon';
  }
}


